import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    return (
      <div
        className="Footer">
        {this.props.appTheme.logoPath && <img
          alt="Company logo"
          src={this.props.appTheme.logoPath} />}
        <p
          className="powered-by">{this.props.appTheme.footer.text.split('\n').map((item, key) => <span key={key}>{item}<br/></span>)}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js